import {Alert, Button, Modal} from 'react-bootstrap'
import PropTypes from 'prop-types'
import {useEffect, useState} from 'react'

import {useWycofajProjekt} from '../../../../../api/domain/elementyRejstru/mutations/useWycofajProjekt.jsx'
import {useUsunProjekt} from '../../../../../api/domain/elementyRejstru/mutations/useUsunProjekt.jsx'
import {useProsbaAnulujProjekt} from '../../../../../api/domain/elementyRejstru/mutations/useProsbaAnulujProjekt.jsx'
import {useAnulujProjekt} from '../../../../../api/domain/elementyRejstru/mutations/useAnulujProjekt.jsx'
import {useOdrzucAnulujProjekt} from '../../../../../api/domain/elementyRejstru/mutations/useOdrzucAnulujProjekt.jsx'
import {useArchiwizujProjekt} from '../../../../../api/domain/elementyRejstru/mutations/useArchiwizujProjekt.jsx'
import {usePoprosOdblokowanieSprawozdanie} from '../../../../../api/domain/elementyRejstru/mutations/usePoprosOdblokowanieSprawozdanie.jsx'
import {useOdblokowanieSprawozdanie} from '../../../../../api/domain/elementyRejstru/mutations/useOdblokowanieSprawozdanie.jsx'
import {useOdrzucOdblokowanieSprawozdanie} from '../../../../../api/domain/elementyRejstru/mutations/useOdrzucOdblokowanieSprawozdanie.jsx'

import {useListaElementow} from '../../../../../api/domain/elementyRejstru/queries/useListaElementow.jsx'
import {SimpleTable} from '../../../../common/simpleTable/SimpleTable.jsx'
import {createTableLista} from '../columns/tableListaProjektow.jsx'
import ButtonWithIcon from '../../../../common/ButtonWithIcon.jsx'
import {Icons} from '../../../../common/Icons.jsx'
import InputNumeric from '../../../../common/inputs/InputNumeric.jsx'
import {useZlozKarteProjektu} from '../../../../../api/domain/elementyRejstru/mutations/useZlozKarteProjektu'
import {useHistoriaProjektu} from '../../../../../api/domain/elementyRejstru/queries/useHistoriaProjektu.jsx'
import {tableHistoriaProjektu} from '../columns/tableHistoriaProjektu.jsx'
import {useKlonujProjekt} from '../../../../../api/domain/elementyRejstru/mutations/useKlonujProjekt.jsx'
import {
    usePowiazOsobeZProjektem
} from '../../../../../api/domain/elementyRejstru/mutations/usePowiazOsobeZProjektem.jsx'
import {
    useOdwiazOsobeOdProjektu
} from '../../../../../api/domain/elementyRejstru/mutations/useOdwiazOsobeOdProjektu.jsx'
import {Select, Textarea} from '../../../../common/inputs/index.js'
import {usePoprosOdblokowanieHarm} from "../../../../../api/domain/planHarm/mutations/usePoprosOdblokowanieHarm.jsx";
import {useOdblokowanieHarm} from "../../../../../api/domain/planHarm/mutations/useOdblokowanieHarm.jsx";
import {useOdrzucOdblokowanieHarm} from "../../../../../api/domain/planHarm/mutations/useOdrzucOdblokowanieHarm.jsx";
import {optionsHarmStatus, optionsPowodAnulowania, optionsProjektStatus} from "../../../../utils/options.js";
import {usePoprosOdblokowanieKp} from "../../../../../api/domain/elementyRejstru/mutations/usePoprosOdblokowanieKp.jsx";
import {useOdblokowanieKp} from "../../../../../api/domain/elementyRejstru/mutations/useOdblokowanieKp.jsx";
import {useOdrzucOdblokowanieKp} from "../../../../../api/domain/elementyRejstru/mutations/useOdrzucOdblokowanieKp.jsx";
import {useProsbaWznowienieKp} from "../../../../../api/domain/elementyRejstru/mutations/useProsbaWznowienieKp.jsx";
import {useWznowienieKp} from "../../../../../api/domain/elementyRejstru/mutations/useWznowienieKp.jsx";
import {useOdrzucWznowienieKp} from "../../../../../api/domain/elementyRejstru/mutations/useOdrzucWznowienieKp.jsx";
import {
    useDodajZdarzenieProcesuProjektu
} from "../../../../../api/domain/elementyRejstru/mutations/useDodajZdarzenieProcesuProjektu.jsx";
import moment from "moment/moment";
import DateTime from "../../../../common/inputs/DateTime.jsx";
import {
    useDodajZdarzenieProcesuHarm
} from "../../../../../api/domain/elementyRejstru/mutations/useDodajZdarzenieProcesuHarm.jsx";
import {usePozycjeSlownika} from "../../../../../api/domain/slowniki/queries/usePozycjeSlownika.jsx";
import {useHistoriaPlanHarm} from "../../../../../api/domain/elementyRejstru/queries/useHistoriaPlanHarm.jsx";
import {useHistoriaSprawozdanie} from "../../../../../api/domain/sprawozdania/queries/useHistoriaSprawozdanie.jsx";
import {useProsbaTymczasoweOdblokuj} from "../../../../../api/domain/sprawozdania/mutations/useProsbaTymczasoweOdblokuj.jsx";
import {useTymczasoweOdblokuj} from "../../../../../api/domain/sprawozdania/mutations/useTymczasoweOdblokuj.jsx";
import {useCofnijTymczasoweOdblokuj} from "../../../../../api/domain/sprawozdania/mutations/useCofnijTymczasoweOdblokuj.jsx";
import {useOdrzucProsbaTymczasoweOdblokuj} from "../../../../../api/domain/sprawozdania/mutations/useOdrzucProsbaTymczasoweOdblokuj.jsx";
import {useDostepneStatusyProjekt} from "../../../../../api/domain/elementyRejstru/queries/useDostepneStatusyProjekt.jsx";
import {useDostepneStatusyPlanHarm} from "../../../../../api/domain/planHarm/queries/useDostepneStatusyPlanHarm.jsx";
import {useKontaPowiazaneProfilu} from '../../../../../api/domain/profile/queries/useKontaPowiazaneProfilu.jsx'
import {tableListaKontProfilu} from '../../../profile/lib/columns/tableListaKontProfilu.jsx'
import {useSelector} from 'react-redux'
import {useListaProfiliProjktu} from '../../../../../api/domain/elementyRejstru/queries/useListaProfiliProjektu.jsx'
import {usePrzepnijProjekt} from "../../../../../api/domain/elementyRejstru/mutations/usePrzepnijProjekt.jsx";
import {useProfile} from "../../../../../api/domain/profile/queries/useProfile.jsx";

export const ModalUsunProjekty = ({currPozycja, show, handleClose}) => {
    const usun = useUsunProjekt()

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Usuwanie elementu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Czy na pewno chcesz usunąć element {currPozycja.id}?
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Anuluj
                </Button>
                <Button
                    variant='danger'
                    onClick={() => {
                        handleClose()
                        usun.mutate(currPozycja.id)
                    }}
                >
                    Usuń
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalUsunProjekty.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalWycofajProjekt = ({currPozycja, show, handleClose}) => {
    const wycofaj = useWycofajProjekt()

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Wycofywanie projektu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Czy na pewno chcesz wycofać projekt {currPozycja?.id}?
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Anuluj
                </Button>
                <Button
                    variant='danger'
                    onClick={() => {
                        handleClose()
                        wycofaj.mutate(currPozycja?.id)
                    }}
                >
                    Wycofaj
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalWycofajProjekt.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalDodajOsobePowiazana = ({currPozycja, show, handleClose}) => {

    const powiaz = usePowiazOsobeZProjektem()
    const rola = useSelector((state) => state.user?.role)
    const currentUserId = useSelector((state) => state.user?.user?.user_id ?? state.user?.user?.id)
    const permissions = useSelector((state) => state.user?.permissions)
    const hasOwnerPermission = Array.isArray(permissions)
        ? permissions.includes('owner')
        : Boolean(permissions?.owner);
    const isWpOwner = rola === 'wp' && hasOwnerPermission
    const profilId = useSelector((state) => state.user?.profilId || state.user?.user?.profil_id || state.user?.user?.profilId)
    const {data: kontaPowiazaneProfilu} = useKontaPowiazaneProfilu(
        profilId,
        show
    )
    const {data: przypisaniDoProjektu} = useListaProfiliProjktu(
        currPozycja?.id,
        show && Boolean(currPozycja?.id)
    )

    const listaKont = Array.isArray(kontaPowiazaneProfilu)
        ? kontaPowiazaneProfilu
        : kontaPowiazaneProfilu?.list || []
    const listaKontDoPowiazania = listaKont.filter((konto) => {
        if (currentUserId === null || currentUserId === undefined) {
            return true
        }
        return String(konto?.id) !== String(currentUserId)
    })
    const przypisaneUserIds = new Set(
        (Array.isArray(przypisaniDoProjektu) ? przypisaniDoProjektu : przypisaniDoProjektu?.list || [])
            .map((item) => item?.user_id)
            .filter(Boolean)
    )

    const handlePowiaz = async (konto) => {
        if (!isWpOwner) {
            return
        }

        await powiaz.mutate({
            rejestr_id: currPozycja?.id,
            user_id: konto?.id,
            email: konto?.email,
        })
        handleClose()
    }

    const th = () => <th>Akcje</th>
    const td = (row) => (
        <td>
            <Button
                size='sm'
                variant='success'
                disabled={powiaz.isPending || !isWpOwner || przypisaneUserIds.has(row?.id)}
                onClick={() => handlePowiaz(row)}
            >
                {przypisaneUserIds.has(row?.id) ? 'Powiązany' : 'Powiąż'}
            </Button>
        </td>
    )

    return (
        <Modal size={'xl'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Dodawanie osoby do projektu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Dodaj osobę odpowiedzialną za projekt o id:{' '}
                    {currPozycja.id}
                </p>
                <SimpleTable
                    detailKey={`rejestr_powiaz_profile_${profilId}_${currPozycja?.id}`}
                    columns={tableListaKontProfilu}
                    addTh={th}
                    addTd={td}
                    data={listaKontDoPowiazania}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalDodajOsobePowiazana.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalOdwiazOsobeOdProjektu = ({
                                               currPozycja,
                                               show,
                                               handleClose,
                                           }) => {
    const odwiaz = useOdwiazOsobeOdProjektu()
    const [form, setForm] = useState(null)
    const clear = async () => {
        await setForm(null)
        handleClose()
    }
    return (
        <Modal size={'lg'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Usuwanie osoby z projektu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Usuń <strong>{currPozycja.email}</strong> z projektu o id:{' '}
                    {currPozycja.id}
                </p>
                <p>Pamiętaj, że operacja jest nieodwracalna!</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={clear}>
                    Zamknij
                </Button>
                <Button
                    variant='danger'
                    onClick={async () => {
                        await odwiaz.mutate({
                            rejestr_id: currPozycja.id,
                            user_id: currPozycja.user_id,
                        })
                        await clear()
                    }}
                >
                    Usuń użytkownika
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalOdwiazOsobeOdProjektu.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalUsunProjekt = ({currPozycja, show, handleClose}) => {
    const usun = useUsunProjekt()

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Usuwanie elementu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Czy na pewno chcesz usunąć element {currPozycja.id}?
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Anuluj
                </Button>
                <Button
                    variant='danger'
                    onClick={() => {
                        handleClose()
                        usun.mutate(currPozycja.id)
                    }}
                >
                    Usuń
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalUsunProjekt.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalHistoria = ({currPozycja, show, handleClose}) => {
    const {data: historiaProjektu} = useHistoriaProjektu(currPozycja.id, show)
    const detailKey = `historia_projektu`
    return (
        <Modal size={'xl'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Historia projektu o id {currPozycja.id}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <SimpleTable
                    detailKey={detailKey}
                    columns={tableHistoriaProjektu}
                    addTh={() => null}
                    addTd={() => null}
                    data={historiaProjektu?.list}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalHistoria.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalHistoriaPlanHarm = ({currPozycja, show, handleClose}) => {
    const {data: historiaPlanHarm} = useHistoriaPlanHarm(currPozycja.id, show)
    const detailKey = `historia_plan_harm`
    return (
        <Modal size={'xl'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Historia planowanego harmonogramu dla projektu o id {currPozycja.id}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <SimpleTable
                    detailKey={detailKey}
                    columns={tableHistoriaProjektu}
                    addTh={() => null}
                    addTd={() => null}
                    data={historiaPlanHarm?.list}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalHistoriaPlanHarm.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalHistoriaSprawozdanie = ({currPozycja, show, handleClose}) => {
    const {data: historiaSprawozdanie} = useHistoriaSprawozdanie(currPozycja.id, show)
    const detailKey = `historia_sprawozdanie`
    return (
        <Modal size={'xl'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Historia sprawozdania dla projektu o id {currPozycja.id}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <SimpleTable
                    detailKey={detailKey}
                    columns={tableHistoriaProjektu}
                    addTh={() => null}
                    addTd={() => null}
                    data={historiaSprawozdanie?.list}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalHistoriaSprawozdanie.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalWyszukajProjekt = ({show, handleClose, setField}) => {
    const handleChoose = (id) => {
        setField('rejestr_id', id)
        handleClose()
    }

    const wszystkieProjekty = useListaElementow('wszystkie')

    return (
        <Modal size={'xl'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Wyszukiwanie projektu do poprawy</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Wyszukaj projekt</p>
                <SimpleTable
                    columns={createTableLista()?.filter(
                        (item) => item?.poprawa
                    )}
                    addTh={() => <th width={150}>Akcje</th>}
                    addTd={(row) => (
                        <td>
                            <ButtonWithIcon
                                icon={<Icons.choose/>}
                                onClick={() => handleChoose(row.id)}
                                variant={'primary'}
                                text={'Wybierz'}
                            />
                        </td>
                    )}
                    data={wszystkieProjekty.data}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalWyszukajProjekt.propTypes = {
    show: PropTypes.bool,
    handleClose: PropTypes.func,
    setField: PropTypes.func,
}

export const ModalKlonujProjekt = ({currPozycja, show, handleClose}) => {
    const klonuj = useKlonujProjekt()

    return (
        <Modal size={'lg'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Klonowanie projektu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Czy na pewno chcesz sklonować projekt {currPozycja?.id}?
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Anuluj
                </Button>
                <Button
                    variant='success'
                    onClick={() => {
                        handleClose()
                        klonuj.mutate(currPozycja?.id)
                    }}
                >
                    Klonuj
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
ModalKlonujProjekt.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalProsbaOdblokujHarmonogram = ({currPozycja, show, handleClose}) => {
    const odblokuj = usePoprosOdblokowanieHarm()
    const [uzasadnienie, setUzasadnienie] = useState('')
    const handleZapisz = async () => {
        await odblokuj.mutate({
            rejestr_id: currPozycja.id,
            uzasadnienie_prosba_odblokowanie: uzasadnienie,
            id: currPozycja.plan_harm_id

        })
        setUzasadnienie('')
        handleClose()
    }
    useEffect(() => {
            setUzasadnienie('')
            return () => {
                setUzasadnienie('')
            }
        }
        , [currPozycja.id])
    return (
        <Modal size={''} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Prośba o odblokowanie planowanego harmonogramu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Czy na pewno chcesz poprosić o odblokowanie planowanego harmonogramu projektu o id {currPozycja.id}?
                </p>
                <Textarea
                    title={'Uzasadnienie'}
                    rows={3}
                    placeholder={'Wprowadź uzasadnienie'}
                    label={'Uzasadnienie'}
                    value={uzasadnienie}
                    onChange={(e) => setUzasadnienie(e.target.value)}
                    limit={2000}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
                <Button variant='success' onClick={handleZapisz} disabled={!uzasadnienie}>
                    Zapisz
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalProsbaOdblokujHarmonogram.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalOdblokujHarmonogram = ({currPozycja, show, handleClose}) => {
    const odblokuj = useOdblokowanieHarm()
    const odrzuc = useOdrzucOdblokowanieHarm()
    const [komentarzPW, setKomentarzPW] = useState('')
    
    useEffect(() => {
        if (show) {
            setKomentarzPW('')
        }
    }, [show])
    
    const handleOdblokuj = async () => {
        await odblokuj.mutate({
            rejestr_id: currPozycja.id,
            id: currPozycja.plan_harm_id,
            komentarz_pw: komentarzPW || null,
        })
        handleClose()
    }
    
    const handleOdrzuc = async () => {
        await odrzuc.mutate({
            id: currPozycja.plan_harm_id,
            komentarz_pw: komentarzPW || null,
        })
        handleClose()
    }

    const uzasadnienie = currPozycja?.plan_harm_uzasadnienie_prosba_odblokowanie

    return (
        <Modal size={'lg'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Odblokowanie planowanego harmonogramu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Czy na pewno chcesz odblokować planowany harmonogram projektu o id <strong>{currPozycja.id}</strong>?
                </p>
                <p>
                    Tytuł: <strong>{currPozycja.tytul || '-'}</strong>
                </p>
                {uzasadnienie && (
                    <div className="alert alert-warning">
                        <h6 className="fw-bold">Prośba o odblokowanie</h6>
                        <p className="mb-0"><strong>Uzasadnienie:</strong> {uzasadnienie}</p>
                    </div>
                )}
                <hr />
                <h6 className="fw-bold">Decyzja Administratora</h6>
                <Textarea
                    title={'Komentarz'}
                    rows={3}
                    label={'Komentarz (opcjonalnie)'}
                    value={komentarzPW}
                    onChange={(e) => setKomentarzPW(e.target.value)}
                    limit={2000}
                />
                <div className="alert alert-info mt-3">
                    <strong>Uwaga!</strong> Po odblokowaniu harmonogram zostanie przekazany do ponownej edycji przez właściciela projektu.
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
                {uzasadnienie && (
                    <Button variant='danger' onClick={handleOdrzuc} disabled={odrzuc.isPending}>
                        Odrzuć prośbę
                    </Button>
                )}
                <Button variant='success' onClick={handleOdblokuj} disabled={odblokuj.isPending}>
                    Odblokuj
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalOdblokujHarmonogram.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalOcenProjekt = ({currPozycja, show, handleClose}) => {
    const [waga, setWaga] = useState(currPozycja?.waga)
    const zloz = useZlozKarteProjektu(currPozycja.id)

    const handleZapisz = async () => {
        await zloz.mutate({id: currPozycja.id, waga})
        setWaga(currPozycja?.waga)
        handleClose()
    }

    useEffect(() => {
        setWaga(currPozycja?.waga)
        return () => {
            setWaga(currPozycja?.waga)
        }
    }, [currPozycja.id, currPozycja?.waga])

    return (
        <Modal size={''} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Ocenianie projektu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Oceń projekt o id {currPozycja.id} użytkownika{' '}
                    {currPozycja.assigned_user_imie +
                        ' ' +
                        currPozycja.assigned_user_nazwisko}
                    :
                    <strong>
                        {currPozycja.dotyczy || 'brak opisu czego dotyczy'}
                    </strong>
                </p>
                <InputNumeric
                    title={'Waga projektu'}
                    initial={currPozycja?.waga}
                    value={waga}
                    onChange={(e) => setWaga(e.target.value)}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>

                <Button variant='success' onClick={handleZapisz}>
                    Zapisz
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalOcenProjekt.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}


export const ModalProcesProjektu = ({currPozycja, show, handleClose}) => {
    const dodajZdarzenie = useDodajZdarzenieProcesuProjektu()
    const rejestrId = currPozycja?.id
    const {data: dostepneStatusy} = useDostepneStatusyProjekt(rejestrId, show && !!rejestrId)

    const [form, setForm] = useState({
        status: '',
        data_zdarzenia: null,
        uwagi: '',
        wersja: currPozycja?.wersja,
        rejestr_id: currPozycja?.id
    })

    const updateForm = (field, value) => setForm({...form, [field]: value})

    const filteredStatusOptions = optionsProjektStatus.filter(
        option => dostepneStatusy?.dostepne_statusy?.includes(option.id) || option.id === ''
    )

    const hasAvailableStatuses = filteredStatusOptions.length > 0

    return (
        <Modal size={'lg'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Proces projektu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Dodawanie zdarzenia procesu projektu o id {currPozycja?.id}
                </p>
                <p className="text-muted small">
                    Aktualny status: <strong>{dostepneStatusy?.aktualny_status || '-'}</strong>
                </p>
                {!hasAvailableStatuses && (
                    <div className="alert alert-info">
                        {['ZAKOŃCZONY', 'ZAKOŃCZONA'].includes(dostepneStatusy?.aktualny_status)
                            ? 'Proces został zakończony. Brak dostępnych dalszych kroków.'
                            : 'Następny krok w procesie należy do właściciela projektu.'}
                    </div>
                )}
                {hasAvailableStatuses && (
                    <>
                        <Select
                            onChange={(e) => updateForm('status', e.target.value)}
                            value={form.status}
                            title={'Status'}
                            label={'Status'}
                            options={filteredStatusOptions}
                        />
                        <DateTime
                            hideTime
                            title={'Data zdarzenia'}
                            label={'Data zdarzenia'}
                            value={form?.data_zdarzenia}
                            onChange={(e) =>
                                updateForm('data_zdarzenia', !e ? null : moment(e).format('YYYY-MM-DD'))
                            }
                            dateFormat={'YYYY-MM-DD'}
                            timeFormat={false}
                        />
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
                {hasAvailableStatuses && (
                    <Button
                        variant='success'
                        disabled={!form.status}
                        onClick={async () => {
                            await dodajZdarzenie.mutate({
                                ...form,
                                rejestr_id: currPozycja?.id
                            })
                            setForm({status: '', data_zdarzenia: null, uwagi: '', wersja: currPozycja?.wersja, rejestr_id: currPozycja?.id})
                            handleClose()
                        }}
                    >
                        Zapisz zdarzenie
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    )
}

ModalProcesProjektu.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
    proces: PropTypes.array
}

export const ModalProcesHarmonogramu = ({currPozycja, show, handleClose}) => {
    const dodajZdarzenie = useDodajZdarzenieProcesuHarm()
    const planHarmId = currPozycja?.plan_harm_id
    const {data: dostepneStatusy} = useDostepneStatusyPlanHarm(planHarmId, show && !!planHarmId)

    const [form, setForm] = useState({
        status: '',
        data_zdarzenia: null,
        wersja: currPozycja?.plan_harm_wersja,
        rejestr_id: currPozycja?.id,
        plan_harm_id: currPozycja?.plan_harm_id
    })

    const updateForm = (field, value) => setForm({...form, [field]: value})

    const filteredStatusOptions = optionsHarmStatus.filter(
        option => dostepneStatusy?.dostepne_statusy?.includes(option.id) || option.id === ''
    )

    const hasAvailableStatuses = filteredStatusOptions.length > 0

    return (
        <Modal size={'lg'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Proces planowanego harmonogramu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Dodawanie zdarzenia procesu planowanego harmonogramu dla projektu o id {currPozycja?.id}
                </p>
                <p className="text-muted small">
                    Aktualny status: <strong>{dostepneStatusy?.aktualny_status || '-'}</strong>
                </p>
                {!hasAvailableStatuses && (
                    <div className="alert alert-info">
                        {['ZAKOŃCZONY', 'ZAKOŃCZONA'].includes(dostepneStatusy?.aktualny_status)
                            ? 'Proces został zakończony. Brak dostępnych dalszych kroków.'
                            : 'Następny krok w procesie należy do właściciela projektu.'}
                    </div>
                )}
                {hasAvailableStatuses && (
                    <>
                        <Select
                            onChange={(e) => updateForm('status', e.target.value)}
                            value={form.status}
                            title={'Status'}
                            label={'Status'}
                            options={filteredStatusOptions}
                        />
                        <DateTime
                            hideTime
                            title={'Data zdarzenia'}
                            label={'Data zdarzenia'}
                            value={form?.data_zdarzenia}
                            onChange={(e) =>
                                updateForm('data_zdarzenia', !e ? null : moment(e).format('YYYY-MM-DD'))
                            }
                            dateFormat={'YYYY-MM-DD'}
                            timeFormat={false}
                        />
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
                {hasAvailableStatuses && (
                    <Button
                        variant='success'
                        disabled={!form.status}
                        onClick={async () => {
                            await dodajZdarzenie.mutate({
                                ...form,
                                rejestr_id: currPozycja?.id,
                                plan_harm_id: currPozycja?.plan_harm_id,
                                wersja: currPozycja?.plan_harm_wersja
                            })
                            setForm({status: '', data_zdarzenia: null, wersja: currPozycja?.plan_harm_wersja, rejestr_id: currPozycja?.id, plan_harm_id: currPozycja?.plan_harm_id})
                            handleClose()
                        }}
                    >
                        Zapisz zdarzenie
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    )
}
ModalProcesHarmonogramu.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
    proces: PropTypes.array
}

export const ModalProsbaOdblokujKp = ({currPozycja, show, handleClose}) => {
    const odblokuj = usePoprosOdblokowanieKp()
    const [uzasadnienie, setUzasadnienie] = useState('')
    const handleZapisz = async () => {
        await odblokuj.mutate({
            id: currPozycja.id,
            uzasadnienie_prosba_odblokowanie: uzasadnienie,
        })
        setUzasadnienie('')
        handleClose()
    }
    useEffect(() => {
            setUzasadnienie('')
            return () => {
                setUzasadnienie('')
            }
        }
        , [currPozycja.id])
    return (
        <Modal size={''} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Prośba o odblokowanie karty projektu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Czy na pewno chcesz poprosić o odblokowanie karty projektu o id {currPozycja.id}?
                </p>
                <Textarea
                    title={'Uzasadnienie'}
                    rows={3}
                    placeholder={'Wprowadź uzasadnienie'}
                    label={'Uzasadnienie'}
                    value={uzasadnienie}
                    onChange={(e) => setUzasadnienie(e.target.value)}
                    limit={2000}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
                <Button variant='success' onClick={handleZapisz} disabled={!uzasadnienie}>
                    Zapisz
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalProsbaOdblokujKp.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalOdblokujKp = ({currPozycja, show, handleClose}) => {
    const odblokuj = useOdblokowanieKp()
    const odrzuc = useOdrzucOdblokowanieKp()
    const [komentarzPW, setKomentarzPW] = useState('')
    
    useEffect(() => {
        if (show) {
            setKomentarzPW('')
        }
    }, [show])
    
    const handleOdblokuj = async () => {
        await odblokuj.mutate({
            id: currPozycja.id,
            komentarz_pw: komentarzPW || null,
        })
        handleClose()
    }
    
    const handleOdrzuc = async () => {
        await odrzuc.mutate({
            id: currPozycja.id,
            komentarz_pw: komentarzPW || null,
        })
        handleClose()
    }

    const uzasadnienie = currPozycja?.projekt_uzasadnienie_prosba_odblokowanie

    return (
        <Modal size={'lg'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Odblokowanie karty projektu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Czy na pewno chcesz odblokować kartę projektu o id <strong>{currPozycja.id}</strong>?
                </p>
                <p>
                    Tytuł: <strong>{currPozycja.tytul || '-'}</strong>
                </p>
                {uzasadnienie && (
                    <div className="alert alert-warning">
                        <h6 className="fw-bold">Prośba o odblokowanie</h6>
                        <p className="mb-0"><strong>Uzasadnienie:</strong> {uzasadnienie}</p>
                    </div>
                )}
                <hr />
                <h6 className="fw-bold">Decyzja Administratora</h6>
                <Textarea
                    title={'Komentarz'}
                    rows={3}
                    label={'Komentarz (opcjonalnie)'}
                    value={komentarzPW}
                    onChange={(e) => setKomentarzPW(e.target.value)}
                    limit={2000}
                />
                <div className="alert alert-info mt-3">
                    <strong>Uwaga!</strong> Po odblokowaniu karta projektu zostanie przekazana do ponownej edycji przez właściciela projektu.
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
                {uzasadnienie && (
                    <Button variant='danger' onClick={handleOdrzuc} disabled={odrzuc.isPending}>
                        Odrzuć prośbę
                    </Button>
                )}
                <Button variant='success' onClick={handleOdblokuj} disabled={odblokuj.isPending}>
                    Odblokuj
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalOdblokujKp.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalWyszukajZrodloFinansowania = ({ show, handleClose, onChoose, sources = [] }) => {
    const zrodlaFinansowania = usePozycjeSlownika('zrodla_finansowania')
    const raw = zrodlaFinansowania?.data || zrodlaFinansowania?.list || []
    const data = Array.isArray(raw) ? raw : (raw?.list || []);
    const columns = [
        { header: 'Nazwa', accessorKey: 'nazwa', enableColumnFilter: true, filterFn: 'includesString' },
    ];

    return (
        <Modal size={'lg'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Wybierz źródło finansowania</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Wybierz źródło z listy:</p>

                <SimpleTable
                    columns={columns}
                    hideGlobalFilter
                    hideColumnVisibility
                    hideExport
                    addTh={() => <th width={140}>Akcje</th>}
                    addTd={(row) => {
                        const payload = row?.original ?? row;

                        return (
                            <td>
                                <ButtonWithIcon
                                    icon={<Icons.choose/>}
                                    onClick={() => {
                                        onChoose && onChoose(payload);
                                        handleClose && handleClose();
                                    }}
                                    variant={'primary'}
                                    text={'Wybierz'}
                                />
                            </td>
                        );
                    }}
                    data={data}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalWyszukajZrodloFinansowania.propTypes = {
    show: PropTypes.bool,
    handleClose: PropTypes.func,
    onChoose: PropTypes.func,
    sources: PropTypes.array,
}


export const ModalProsbaAnulujProjekt = ({currPozycja, show, handleClose}) => {
    const prosbaAnuluj = useProsbaAnulujProjekt()
    const [uzasadnienie, setUzasadnienie] = useState('')
    const minUzasadnienie = 10

    const handleZapisz = async () => {
        await prosbaAnuluj.mutate({
            id: currPozycja.id,
            uzasadnienie_anulowania: uzasadnienie,
        })
        setUzasadnienie('')
        handleClose()
    }

    useEffect(() => {
        setUzasadnienie('')
        return () => {
            setUzasadnienie('')
        }
    }, [currPozycja.id])

    const isValid = uzasadnienie.length >= minUzasadnienie

    return (
        <Modal size={'lg'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Prośba o anulowanie karty projektu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Czy na pewno chcesz wysłać prośbę o anulowanie karty projektu o id <strong>{currPozycja.id}</strong>?
                </p>
                <p className="text-muted small">
                    Tytuł: <strong>{currPozycja.tytul || '-'}</strong>
                </p>
                <Textarea
                    title={'Uzasadnienie'}
                    rows={4}
                    placeholder={`Wprowadź uzasadnienie (min. ${minUzasadnienie} znaków)`}
                    label={'Uzasadnienie'}
                    value={uzasadnienie}
                    onChange={(e) => setUzasadnienie(e.target.value)}
                    limit={2000}
                />
                {uzasadnienie.length > 0 && uzasadnienie.length < minUzasadnienie && (
                    <small className="text-danger">
                        Uzasadnienie musi zawierać co najmniej {minUzasadnienie} znaków (obecnie: {uzasadnienie.length})
                    </small>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Anuluj
                </Button>
                <Button variant='danger' onClick={handleZapisz} disabled={!isValid || prosbaAnuluj.isPending}>
                    Wyślij prośbę
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalProsbaAnulujProjekt.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}


export const ModalAnulujProjekt = ({currPozycja, show, handleClose}) => {
    const anuluj = useAnulujProjekt()
    const odrzuc = useOdrzucAnulujProjekt()
    const [komentarzPW, setKomentarzPW] = useState('')

    useEffect(() => {
        if (show) {
            setKomentarzPW('')
        }
    }, [show])

    const handleAnuluj = async () => {
        await anuluj.mutate({
            id: currPozycja.id,
            komentarz_pw: komentarzPW || null,
        })
        handleClose()
    }

    const handleOdrzuc = async () => {
        await odrzuc.mutate({
            id: currPozycja.id,
            komentarz_pw: komentarzPW || null,
        })
        handleClose()
    }

    const uzasadnienie = currPozycja?.uzasadnienie_anulowania

    return (
        <Modal size={'lg'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Anulowanie karty projektu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Czy na pewno chcesz anulować kartę projektu o id <strong>{currPozycja.id}</strong>?
                </p>
                <p>
                    Tytuł: <strong>{currPozycja.tytul || '-'}</strong>
                </p>
                {uzasadnienie && (
                    <div className="alert alert-warning">
                        <h6 className="fw-bold">Prośba o anulowanie</h6>
                        <p className="mb-0"><strong>Uzasadnienie:</strong> {uzasadnienie}</p>
                    </div>
                )}
                <hr />
                <h6 className="fw-bold">Decyzja Administratora</h6>
                <Textarea
                    title={'Komentarz'}
                    rows={3}
                    label={'Komentarz (opcjonalnie)'}
                    value={komentarzPW}
                    onChange={(e) => setKomentarzPW(e.target.value)}
                    limit={2000}
                />
                <div className="alert alert-danger mt-3">
                    <strong>Uwaga!</strong> Po anulowaniu projekt zostanie zablokowany do dalszej edycji i obsługi po stronie właściciela projektu.
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
                {uzasadnienie && (
                    <Button variant='warning' onClick={handleOdrzuc} disabled={odrzuc.isPending}>
                        Odrzuć prośbę
                    </Button>
                )}
                <Button variant='danger' onClick={handleAnuluj} disabled={anuluj.isPending}>
                    Potwierdź anulowanie
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalAnulujProjekt.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalArchiwizujProjekt = ({currPozycja, show, handleClose}) => {
    const archiwizuj = useArchiwizujProjekt()

    const handleArchiwizuj = async () => {
        await archiwizuj.mutate({id: currPozycja.id})
        handleClose()
    }

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Archiwizacja karty projektu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Czy na pewno chcesz zarchiwizować kartę projektu o id <strong>{currPozycja.id}</strong>?
                </p>
                <p>
                    Tytuł: <strong>{currPozycja.tytul || '-'}</strong>
                </p>
                <div className="alert alert-warning mt-3">
                    <strong>Uwaga!</strong> Po archiwizacji projekt zostanie przeniesiony do zakładki Archiwum i nie będzie widoczny na liście aktywnych projektów.
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Anuluj
                </Button>
                <Button variant='dark' onClick={handleArchiwizuj} disabled={archiwizuj.isPending}>
                    Potwierdź archiwizację
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalArchiwizujProjekt.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

 export const ModalPrzepnijProjekt = ({currPozycja, show, handleClose }) => {
    const projectId = currPozycja.id
    const profilId = currPozycja.profil_id
    const listaProfili = useProfile()
    const przepnij = usePrzepnijProjekt()

    const raw = listaProfili?.data || listaProfili?.list || []
    const data = Array.isArray(raw) ? raw : (raw?.list || []);
    const columns = [
        { header: 'ID', accessorKey: 'id', enableColumnFilter: true, filterFn: 'includesString' },
        { header: 'Nazwa', accessorKey: 'nazwa', enableColumnFilter: true, filterFn: 'includesString' },
    ];

    return (
        <Modal size={'xl'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Wybierz nowy profil</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert variant='warning' size={'md'} className='w-50 mx-auto mb-4'>
                    <p className='fw-bold text-center'>UWAGA!</p>
                    <p>Operacja spowoduje:</p>
                    <ul>
                        <li>Zmianę przypisanego profilu i nazwy podmiotu projektu</li>
                        <li>Usunięcie wszystkich powiązań kont użytkowników z projektem</li>
                        <li>Numer projektu nie ulegnie zmianie</li>
                    </ul>
                </Alert>

                <p>Wybierz nowy profil do przepięcia z listy:</p>

                <SimpleTable
                    columns={columns}
                    hideGlobalFilter
                    hideColumnVisibility
                    hideExport
                    addTh={() => <th width={140}>Akcje</th>}
                    addTd={(row) => {
                        const payload = row?.original ?? row;
                        const isCurrentProfile = profilId === payload?.id

                        return (
                            <td>
                                <ButtonWithIcon
                                    icon={<Icons.choose/>}
                                    onClick={() => {
                                        przepnij.mutate({projectId, newProfileId: payload?.id})
                                        handleClose && handleClose();
                                    }}
                                    variant={isCurrentProfile ? 'secondary' : 'primary'}
                                    text={'Wybierz'}
                                    title={'Wybierz nowy profil do przepięcia'}
                                    disabled={isCurrentProfile}
                                />
                            </td>
                        );
                    }}
                    data={data}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalPrzepnijProjekt.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalProsbaOdblokujSprawozdanie = ({currPozycja, show, handleClose}) => {
    const odblokuj = usePoprosOdblokowanieSprawozdanie()
    const [uzasadnienie, setUzasadnienie] = useState('')

    const handleZapisz = async () => {
        await odblokuj.mutate({
            id: currPozycja.sprawozdanie_id,
            uzasadnienie_prosba_odblokowanie: uzasadnienie,
        })
        setUzasadnienie('')
        handleClose()
    }

    useEffect(() => {
        setUzasadnienie('')
        return () => { setUzasadnienie('') }
    }, [currPozycja.sprawozdanie_id])

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Prośba o odblokowanie sprawozdania</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Czy na pewno chcesz poprosić o odblokowanie sprawozdania dla projektu <strong>{currPozycja.tytul || currPozycja.sprawozdanie_id}</strong>?
                </p>
                <Textarea
                    title={'Uzasadnienie'}
                    rows={3}
                    placeholder={'Wprowadź uzasadnienie'}
                    label={'Uzasadnienie'}
                    value={uzasadnienie}
                    onChange={(e) => setUzasadnienie(e.target.value)}
                    limit={2000}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
                <Button variant='success' onClick={handleZapisz} disabled={!uzasadnienie || odblokuj.isPending}>
                    Zapisz
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalProsbaOdblokujSprawozdanie.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalOdblokujSprawozdanie = ({currPozycja, show, handleClose}) => {
    const odblokuj = useOdblokowanieSprawozdanie()
    const odrzuc = useOdrzucOdblokowanieSprawozdanie()
    const [komentarzPW, setKomentarzPW] = useState('')

    useEffect(() => {
        if (show) {
            setKomentarzPW('')
        }
    }, [show])

    const handleOdblokuj = async () => {
        await odblokuj.mutate({
            id: currPozycja.sprawozdanie_id,
            komentarz_pw: komentarzPW || null,
        })
        handleClose()
    }

    const handleOdrzuc = async () => {
        await odrzuc.mutate({
            id: currPozycja.sprawozdanie_id,
            komentarz_pw: komentarzPW || null,
        })
        handleClose()
    }

    const uzasadnienie = currPozycja?.sprawozdanie_uzasadnienie_prosba_odblokowanie

    return (
        <Modal size={'lg'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Odblokowanie sprawozdania</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Czy na pewno chcesz odblokować sprawozdanie dla projektu <strong>{currPozycja.tytul || currPozycja.sprawozdanie_id}</strong>?
                </p>
                {uzasadnienie && (
                    <div className="alert alert-warning">
                        <h6 className="fw-bold">Prośba o odblokowanie</h6>
                        <p className="mb-0"><strong>Uzasadnienie:</strong> {uzasadnienie}</p>
                    </div>
                )}
                <hr />
                <h6 className="fw-bold">Decyzja Administratora</h6>
                <Textarea
                    title={'Komentarz'}
                    rows={3}
                    label={'Komentarz (opcjonalnie)'}
                    value={komentarzPW}
                    onChange={(e) => setKomentarzPW(e.target.value)}
                    limit={2000}
                />
                <div className="alert alert-info mt-3">
                    <strong>Uwaga!</strong> Po odblokowaniu zostanie utworzona nowa wersja sprawozdania do edycji.
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
                {uzasadnienie && (
                    <Button variant='danger' onClick={handleOdrzuc} disabled={odrzuc.isPending}>
                        Odrzuć prośbę
                    </Button>
                )}
                <Button variant='success' onClick={handleOdblokuj} disabled={odblokuj.isPending}>
                    Odblokuj
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalOdblokujSprawozdanie.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalProsbaWznowieniaKp = ({currPozycja, show, handleClose}) => {
    const prosbaWznowienie = useProsbaWznowienieKp()
    const [uzasadnienie, setUzasadnienie] = useState('')
    const minUzasadnienie = 10

    const handleZapisz = async () => {
        await prosbaWznowienie.mutate({
            id: currPozycja.id,
            uzasadnienie_prosba_wznowienia: uzasadnienie,
        })
        setUzasadnienie('')
        handleClose()
    }

    useEffect(() => {
        setUzasadnienie('')
        return () => {
            setUzasadnienie('')
        }
    }, [currPozycja.id])

    const isValid = uzasadnienie.length >= minUzasadnienie

    return (
        <Modal size={'lg'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Prośba o wznowienie karty projektu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Czy na pewno chcesz wysłać prośbę o wznowienie karty projektu o id <strong>{currPozycja.id}</strong>?
                </p>
                <p className="text-muted small">
                    Tytuł: <strong>{currPozycja.tytul || '-'}</strong>
                </p>
                <Textarea
                    title={'Uzasadnienie'}
                    rows={4}
                    placeholder={`Wprowadź uzasadnienie (min. ${minUzasadnienie} znaków)`}
                    label={'Uzasadnienie'}
                    value={uzasadnienie}
                    onChange={(e) => setUzasadnienie(e.target.value)}
                    limit={2000}
                />
                {uzasadnienie.length > 0 && uzasadnienie.length < minUzasadnienie && (
                    <small className="text-danger">
                        Uzasadnienie musi zawierać co najmniej {minUzasadnienie} znaków (obecnie: {uzasadnienie.length})
                    </small>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Anuluj
                </Button>
                <Button variant='success' onClick={handleZapisz} disabled={!isValid || prosbaWznowienie.isPending}>
                    Wyślij prośbę
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalProsbaWznowieniaKp.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalWznowieniaKp = ({currPozycja, show, handleClose}) => {
    const wznowienie = useWznowienieKp()
    const odrzuc = useOdrzucWznowienieKp()
    const [komentarzPW, setKomentarzPW] = useState('')

    useEffect(() => {
        if (show) {
            setKomentarzPW('')
        }
    }, [show])

    const handleWznowienie = async () => {
        await wznowienie.mutate({
            id: currPozycja.id,
            komentarz_pw: komentarzPW || null,
        })
        handleClose()
    }

    const handleOdrzuc = async () => {
        await odrzuc.mutate({
            id: currPozycja.id,
            komentarz_pw: komentarzPW || null,
        })
        handleClose()
    }

    const uzasadnienie = currPozycja?.projekt_uzasadnienie_prosba_wznowienia

    return (
        <Modal size={'lg'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Wznowienie karty projektu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Czy na pewno chcesz wznowić kartę projektu o id <strong>{currPozycja.id}</strong>?
                </p>
                <p>
                    Tytuł: <strong>{currPozycja.tytul || '-'}</strong>
                </p>
                {uzasadnienie && (
                    <div className="alert alert-warning">
                        <h6 className="fw-bold">Prośba o wznowienie</h6>
                        <p className="mb-0"><strong>Uzasadnienie:</strong> {uzasadnienie}</p>
                    </div>
                )}
                <hr />
                <h6 className="fw-bold">Decyzja Administratora</h6>
                <Textarea
                    title={'Komentarz'}
                    rows={3}
                    label={'Komentarz (opcjonalnie)'}
                    value={komentarzPW}
                    onChange={(e) => setKomentarzPW(e.target.value)}
                    limit={2000}
                />
                <div className="alert alert-info mt-3">
                    <strong>Uwaga!</strong> Po wznowieniu karta projektu zostanie przekazana do ponownej edycji.
                    Jeśli projekt posiada powiązany planowany harmonogram w statusie ZŁOŻONY/PRZYJĘTY,
                    zostanie on również odblokowany.
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
                {uzasadnienie && (
                    <Button variant='danger' onClick={handleOdrzuc} disabled={odrzuc.isPending}>
                        Odrzuć prośbę
                    </Button>
                )}
                <Button variant='success' onClick={handleWznowienie} disabled={wznowienie.isPending}>
                    Wznów projekt
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalWznowieniaKp.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalProsbaTymczasoweOdblokujSprawozdanie = ({rejestrId, tytul, show, handleClose}) => {
    const mutation = useProsbaTymczasoweOdblokuj()
    const [uzasadnienie, setUzasadnienie] = useState('')

    useEffect(() => {
        if (show) setUzasadnienie('')
    }, [show])

    const handleSubmit = () => {
        mutation.mutate({
            rejestr_id: rejestrId,
            uzasadnienie: uzasadnienie || null,
        })
        handleClose()
    }

    return (
        <Modal size={'lg'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Prośba o tymczasowe odblokowanie sprawozdawczości</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Okres sprawozdawczy został zakończony. Możesz wysłać prośbę o tymczasowe odblokowanie sprawozdawczości,
                    które umożliwi Ci złożenie sprawozdania po terminie.
                </p>
                {tytul && (
                    <p className="text-muted small">
                        Projekt: <strong>{tytul}</strong>
                    </p>
                )}
                <Textarea
                    title={'Uzasadnienie'}
                    rows={4}
                    placeholder={'Wprowadź uzasadnienie prośby'}
                    label={'Uzasadnienie prośby'}
                    value={uzasadnienie}
                    onChange={(e) => setUzasadnienie(e.target.value)}
                    limit={2000}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
                <Button variant='warning' onClick={handleSubmit} disabled={!uzasadnienie || mutation.isPending}>
                    Wyślij prośbę
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalProsbaTymczasoweOdblokujSprawozdanie.propTypes = {
    rejestrId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tytul: PropTypes.string,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalTymczasoweOdblokujSprawozdanie = ({rejestrId, tytul, uzasadnienieProsba, kwartal, rok, show, handleClose}) => {
    const odblokuj = useTymczasoweOdblokuj()
    const odrzuc = useOdrzucProsbaTymczasoweOdblokuj()
    const [komentarzPW, setKomentarzPW] = useState('')

    useEffect(() => {
        if (show) setKomentarzPW('')
    }, [show])

    const handleOdblokuj = () => {
        odblokuj.mutate({
            rejestr_id: rejestrId,
            komentarz_pw: komentarzPW || null,
            kwartal: kwartal || undefined,
            rok: rok || undefined,
        })
        handleClose()
    }

    const handleOdrzuc = () => {
        odrzuc.mutate({
            rejestr_id: rejestrId,
            komentarz_pw: komentarzPW || null,
        })
        handleClose()
    }

    return (
        <Modal size={'lg'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Tymczasowe odblokowanie sprawozdawczości</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {tytul && (
                    <p className="text-muted small">
                        Projekt: <strong>{tytul}</strong>
                    </p>
                )}
                {uzasadnienieProsba && (
                    <div className="alert alert-warning">
                        <h6 className="fw-bold">Uzasadnienie prośby jednostki:</h6>
                        <p className="mb-0">{uzasadnienieProsba}</p>
                    </div>
                )}
                <hr />
                <h6 className="fw-bold">Decyzja Administratora</h6>
                <Textarea
                    title={'Komentarz'}
                    rows={3}
                    label={'Komentarz (opcjonalnie)'}
                    value={komentarzPW}
                    onChange={(e) => setKomentarzPW(e.target.value)}
                    limit={2000}
                />
                <div className="alert alert-info mt-3">
                    <strong>Uwaga!</strong> Po tymczasowym odblokowaniu jednostka będzie mogła inicjować, edytować i złożyć sprawozdanie
                    mimo zakończenia okresu sprawozdawczego. Tymczasowe odblokowanie sprawozdawczości można cofnąć w dowolnym momencie.
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
                {uzasadnienieProsba && (
                    <Button variant='danger' onClick={handleOdrzuc} disabled={odrzuc.isPending}>
                        Odrzuć prośbę
                    </Button>
                )}
                <Button variant='success' onClick={handleOdblokuj} disabled={odblokuj.isPending}>
                    Tymczasowo odblokuj
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalTymczasoweOdblokujSprawozdanie.propTypes = {
    rejestrId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tytul: PropTypes.string,
    uzasadnienieProsba: PropTypes.string,
    kwartal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rok: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalCofnijTymczasoweOdblokowanieSprawozdanie = ({rejestrId, tytul, show, handleClose}) => {
    const cofnij = useCofnijTymczasoweOdblokuj()
    const [komentarzPW, setKomentarzPW] = useState('')

    useEffect(() => {
        if (show) setKomentarzPW('')
    }, [show])

    const handleCofnij = () => {
        cofnij.mutate({
            rejestr_id: rejestrId,
            komentarz_pw: komentarzPW || null,
        })
        handleClose()
    }

    return (
        <Modal size={'lg'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Cofnięcie tymczasowego odblokowania sprawozdawczości</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Czy na pewno chcesz cofnąć tymczasowe odblokowanie sprawozdawczości?
                    Jednostka nie będzie mogła inicjować, edytować ani składać sprawozdania poza wyznaczonym okresem sprawozdawczym.
                </p>
                {tytul && (
                    <p className="text-muted small">
                        Projekt: <strong>{tytul}</strong>
                    </p>
                )}
                <Textarea
                    title={'Komentarz'}
                    rows={3}
                    label={'Komentarz (opcjonalnie)'}
                    value={komentarzPW}
                    onChange={(e) => setKomentarzPW(e.target.value)}
                    limit={2000}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
                <Button variant='danger' onClick={handleCofnij} disabled={cofnij.isPending}>
                    Cofnij odblokowanie
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalCofnijTymczasoweOdblokowanieSprawozdanie.propTypes = {
    rejestrId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tytul: PropTypes.string,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}
